<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
const props = defineProps({
  to: {
    type: String,
    required: true
  }
});

const route = useRoute();
const active = computed(() => {
  return route.path.includes(props.to);
});
</script>

<template>
  <router-link
    class="nav-menu-link"
    :class="{ 'nav-menu-link--active': active }"
    :to="to"
  >
    <slot></slot>
  </router-link>
</template>

<style lang="scss" scoped>
.nav-menu-link {
  display: block;
  padding: 0 var(--spacing-medium);
  font-size: var(--type-small-body);
  color: var(--color-text-strong);
  line-height: 26px;
  width: 100%;
  &:hover {
    color: var(--color-text-strong);
    background-color: var(--color-bg-strong-emphasis);
  }
  &:focus-visible {
    background-color: var(--color-bg-strong-emphasis);
    color: var(--color-text-strong);
  }
  &--active {
    background-color: var(--color-primary-bg-default);
    &:hover {
      background-color: var(--color-primary-bg-hover);
    }
    &:focus-visible {
      background-color: var(--color-primary-bg-pressed);
    }
  }
}
</style>
